'use client'

import type { ElementType, ReactNode } from 'react'

import { AccordionProvider } from '../shared/accordion/accordion-provider'

export interface FaqQuestion {
  uid: string
  question: string
  answerHtml: string
}

export interface FaqClientProps extends React.PropsWithChildren {
  title?: string
  heading: string
  editableProps?: Record<string, unknown>
  children: ReactNode
}

export const FaqClient = ({ title, heading, editableProps, children }: FaqClientProps) => {
  const HeadingTag = heading as ElementType

  return (
    <AccordionProvider>
      <section
        {...editableProps}
        className="ht-faq flex max-w-full min-w-full shrink-0 flex-col md:min-w-full lg:max-w-[640px] lg:min-w-auto"
      >
        <div className="rounded-2xl bg-white px-7 py-6 md:px-10 md:py-8">
          {title && (
            // Keep article H5 typography independent of the semantic heading level.
            <HeadingTag className="text-navy mt-0! mb-5! flex items-center gap-3 text-[1.6rem]! leading-snug! font-semibold! tracking-normal!">
              {title}
            </HeadingTag>
          )}
          <section className="flex w-full flex-col justify-center">{children}</section>
        </div>
      </section>
    </AccordionProvider>
  )
}
